export default "__VITE_ASSET__5fb2ce81__"